import React, { useState } from 'react';
import { useStateValue } from "../StateProvider";
import "./SongConfirmation.css";

function SongConfirmation() {
  const [{NameOfAddedSong, countUserRatings}, dispatch] = useStateValue();

  // Local state for blog consent and genre
  const [blogConsent, setBlogConsent] = useState(true); // Default: checked
  const [selectedGenre, setSelectedGenre] = useState("None"); // Default: None

  // Genre options
  const genres = [
    "Avant Garde",
    "Blues",
    "Classical",
    "Country",
    "Easy Listening",
    "Electronic",
    "Folk",
    "Hip-Hop/Rap",
    "Indie Rock",
    "Instrumental",
    "Jazz",
    "Kids/Family",
    "Latin",
    "LoFi",
    "Metal",
    "Punk",
    "Post Rock",
    "Alternative Rock",
    "Punk Rock",
    "New Age",
    "Pop",
    "R&B/Soul",
    "Reggae",
    "Rock",
    "Spiritual",
    "None"
  ];

  const handleConfirm = () => {
    // Dispatch blog consent and genre to state
    dispatch({
      type: "SET_BLOGCONSENTSONGTOADD",
      blogConsentSongToAdd: blogConsent,
    });

    dispatch({
      type: "SET_GENRESONGTOADD",
      genreSongToAdd: selectedGenre,
    });

    // Hide the confirmation screen
    dispatch({
      type: "SET_SONGCONFIRMATIONNEEDED",
      songConfirmationNeeded: false,
    });

    // Set flag to proceed to DB write
    dispatch({
      type: "SET_SONGTOADDCHOSEN",
      songToAddChosen: 1,
    });
  };

  const handleGoBack = () => {
    // Reset the confirmation state to go back to search
    dispatch({
      type: "SET_SONGCONFIRMATIONNEEDED",
      songConfirmationNeeded: false,
    });
  };

  return (
    <div className="song-confirmation">
      <div className="confirmation-card">
        <div className="confirmation-header">
          <h1>Confirm Your Song Submission</h1>
          <p className="subtitle">Just a few more details before we add your song!</p>
        </div>

        <div className="selected-song">
          <div className="song-icon">🎵</div>
          <div className="song-details">
            <p className="label">Selected Song:</p>
            <h2>{NameOfAddedSong}</h2>
          </div>
        </div>

        <div className="rating-info">
          <span className="checkmark">✅</span>
          <p>
            {countUserRatings === 0 ? (
              <>No songs were available to rate</>
            ) : (
              <>You've rated <strong>{countUserRatings}</strong> song{countUserRatings === 1 ? '' : 's'}</>
            )}
          </p>
        </div>

        <div className="form-section">
          {/* Genre dropdown */}
          <div className="form-group">
            <label htmlFor="genre-select">
              <span className="label-icon">🎸</span>
              Genre
            </label>
            <select
              id="genre-select"
              value={selectedGenre}
              onChange={(e) => setSelectedGenre(e.target.value)}
              className="genre-select"
            >
              {genres.map((genre) => (
                <option key={genre} value={genre}>
                  {genre}
                </option>
              ))}
            </select>
          </div>

          {/* Blog consent checkbox */}
          <div className="form-group checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={blogConsent}
                onChange={(e) => setBlogConsent(e.target.checked)}
                className="checkbox-input"
              />
              <span className="checkbox-custom"></span>
              <span className="checkbox-text">
                I agree that this song can be featured in the blog section if selected by Songcarousel admins
              </span>
            </label>
          </div>
        </div>

        <div className="button-group">
          <button onClick={handleGoBack} className="btn-secondary">
            ← Go Back
          </button>
          <button onClick={handleConfirm} className="btn-primary">
            Confirm & Submit 🚀
          </button>
        </div>
      </div>
    </div>
  );
}

export default SongConfirmation;
